import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "../lib/api";
import { AlertTriangle, CreditCard, X } from "lucide-react";

const fmtDate = (iso) => (iso ? new Date(`${iso.slice(0, 10)}T12:00:00`).toLocaleDateString("it-IT") : "");

export const BillingBanner = ({ isAdmin }) => {
  const [b, setB] = useState(null);
  const [hidden, setHidden] = useState(false);
  const { pathname } = useLocation();
  const dismissKey = b ? `vivi:billingBannerDismissed:${b.slug}:${b.paid_until}` : null;

  useEffect(() => {
    if (!isAdmin) return;
    const load = () => api.get("/billing/me").then(({ data }) => setB(data)).catch(() => setB(null));
    load();
    window.addEventListener("billing-updated", load);
    return () => window.removeEventListener("billing-updated", load);
  }, [isAdmin]);

  useEffect(() => {
    if (dismissKey) { try { setHidden(sessionStorage.getItem(dismissKey) === "1"); } catch { setHidden(false); } }
  }, [dismissKey]);

  const dismiss = () => { setHidden(true); try { sessionStorage.setItem(dismissKey, "1"); } catch {} };

  if (!isAdmin || !b || hidden || pathname.startsWith("/impostazioni")) return null;
  const autoOn = b.auto_renew?.enabled && b.auto_renew?.status !== "past_due";
  const show = !b.active || (b.paid_until && ["expired", "expiring"].includes(b.status) && !autoOn) || b.auto_renew?.status === "past_due";
  if (!show) return null;

  const expired = !b.active || b.status === "expired";
  const text = b.auto_renew?.status === "past_due"
    ? "L'addebito automatico del canone non è riuscito: controlla la carta."
    : !b.active ? "Il club è sospeso per canone scaduto: rinnova per riattivarlo subito."
    : expired ? `Canone scaduto il ${fmtDate(b.paid_until)}${b.auto_suspend ? " · il club verrà sospeso" : ""}.`
    : `Il canone scade ${b.days_left === 0 ? "oggi" : b.days_left === 1 ? "domani" : `tra ${b.days_left} giorni`} (${fmtDate(b.paid_until)}).`;

  return (
    <div data-testid="billing-banner" className={`mx-4 sm:mx-6 lg:mx-8 mt-4 lg:mt-10 -mb-2 flex items-center gap-3 rounded-xl border px-4 py-2.5 text-sm font-medium ${expired ? "bg-red-50 border-red-300 text-red-900" : "bg-amber-50 border-amber-300 text-amber-900"}`}>
      <AlertTriangle className={`h-4 w-4 shrink-0 ${expired ? "text-red-600" : "text-amber-600"}`} />
      <span className="flex-1 min-w-0" data-testid="billing-banner-text">{text}</span>
      <Link to="/impostazioni" data-testid="billing-banner-renew" className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold text-white transition-colors ${expired ? "bg-red-600 hover:bg-red-500" : "bg-amber-600 hover:bg-amber-500"}`}>
        <CreditCard className="h-3.5 w-3.5" /> Rinnova
      </Link>
      {!expired && <button type="button" onClick={dismiss} data-testid="billing-banner-close" className="p-1 rounded hover:bg-black/10" aria-label="Chiudi"><X className="h-4 w-4" /></button>}
    </div>
  );
};

export default BillingBanner;
